"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartConfig = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IChartConfig}
 */
class ChartConfig {
    constructor(overrides) {
        this.interactionOptions = { disableLongPressContext: true, scrollZooms: true, disableAllInteraction: false };
        this.updateOptions = { updateDimsOnDraw: true, updateAllPlotsOnDraw: false, interactionRollupTime: 500 };
        this.changeDetectionConfig = noChangeDetectionConfig;
        this.changeIdFactory = new rc_js_util_1.IncrementingIdentifierFactory();
        Object.assign(this, overrides);
    }
}
exports.ChartConfig = ChartConfig;
const noChangeDetectionConfig = {
    runOutsideOfChangeDetection: (cb) => cb(),
    runInsideOfChangeDetection: (cb) => cb(),
};
//# sourceMappingURL=chart-config.js.map